export const clamp = (num, min, max) => {
  if (!num && num !== 0) {
    return num;
  }

  const lowerClamp = min || min === 0 ? Math.max(min, num) : num;
  const upperClamp = max || max === 0 ? Math.min(max, lowerClamp) : lowerClamp;

  return upperClamp;
};
